import { GridColumn, GridRow } from '@tkww/orion-web-ds-structure';
import { compose } from '@xo-union/react-css-modules';
import { H2, Subhead } from '@xo-union/tk-ui-typography';
import PropTypes from 'prop-types';
import React from 'react';

import ContentCard from './ContentCard';
import { ChatSVG, OptionSVG, StyleSVG } from './icons';
import Styles from './styles.scss';

/** @internal */
export const categoryToInfoMap = {
	conversation: { name: 'Start a Conversation', icon: ChatSVG },
	options: { name: 'Understand the Options', icon: OptionSVG },
	style: { name: 'Start With Your Style', icon: StyleSVG },
};

const TextContent = ({ header, textContent, className }) => (
	<div className={Styles.textContainer}>
		<GridRow>
			<GridColumn xs="12" className={Styles.head}>
				<H2 className={className}>{header}</H2>
				<Subhead>Advice From The Knot</Subhead>
			</GridColumn>
		</GridRow>

		<GridRow classes={compose({ row: Styles.textRow })}>
			{Object.keys(textContent).map((category) => {
				const { name, icon } = categoryToInfoMap[category];
				const { copyA, copyB } = textContent[category];

				return (
					<GridColumn sm="12" md="4" key={category}>
						<ContentCard icon={icon} header={name}>
							<p className={Styles.contentBody}>{copyA}</p>
							{copyB ? <p className={Styles.contentBody}>{copyB}</p> : null}
						</ContentCard>
					</GridColumn>
				);
			})}
		</GridRow>
	</div>
);

TextContent.propTypes = {
	header: PropTypes.string.isRequired,
	textContent: PropTypes.shape({
		style: PropTypes.shape({
			copyA: PropTypes.string.isRequired,
			copyB: PropTypes.string,
		}),
		options: PropTypes.shape({
			copyA: PropTypes.string.isRequired,
			copyB: PropTypes.string,
		}),
		conversation: PropTypes.shape({
			copyA: PropTypes.string.isRequired,
			copyB: PropTypes.string,
		}),
	}).isRequired,
};

export default TextContent;
